import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TooltipDirective } from '../../directives';

@NgModule({
    imports: [CommonModule],
    declarations: [TooltipDirective],
    exports: [TooltipDirective]
})
export class TooltipDirectiveModule {
}



// WEBPACK FOOTER //
// ./src/app/directives/tooltip/tooltip.directive.module.ts